export class notificationConsts {
  public static readonly type_tap = 'tap';
  public static readonly type_beverage = 'beverage';
  public static readonly alert = 'alert';

}

export class notificationFilters {
  public static readonly beverage = 'beverage';
  public static readonly tap = 'tap';
  public static readonly support = 'support_reply';
}
